<suite-rfb-alert-messages></suite-rfb-alert-messages>

<ng-container *ngIf="recurso">
    <ng-container *ngIf="recurso.idAto">
        <div class="row">
            <div class="col-md-6">
                <label class="control-label" style="padding-left: 44px">Nome do LUD</label>
                <div class="input-group mb-3">
                    <span class="input-group-text"><img src="/favicon-normas.ico"class="icon-normas"></span>
                    <input type="text" class="form-control" [(ngModel)]="recurso.identificador">
                </div>
            </div>
            <div class="col-md-2">
                <label class="control-label">ID do ato</label>
                <input type="text" name="idAto" class="form-control" [(ngModel)]="recurso.idAto" readonly>
            </div>
            <div class="col-md-4">
                    <label class="control-label">&nbsp;</label>
                <div class="form-group" style="text-align: right">
                    <suite-rfb-confirmation-link popupTitle="Excluir do banco de LUDs" (accept)="excluirRecurso()"
                            question="O recurso será excluído! Confirma a operação?" style="margin-right: 1em;">
                        <button [disabled]="!recurso.idRecurso" type="button" class="btn btn-default btn-sm">Excluir do banco</button>
                    </suite-rfb-confirmation-link>
                    <button type="button" class="btn btn-default btn-sm" title="Salvar no banco de LUDs" (click)="salvarRecurso()">Salvar no banco</button>
                </div>
            </div>
        </div>
    </ng-container>
    
    <ng-container *ngIf="!recurso.idAto">
        <div class="row">
            <div class="col-md-8">
                <label class="control-label" style="padding-left: 44px">Nome do LUD</label>
                <div class="input-group">
                    <span class="input-group-text"><em class="material-icons icon-24">language</em></span>
                    <input type="text" class="form-control" [(ngModel)]="recurso.identificador">
                </div>
            </div>
            <div class="col-md-4">
                <label class="control-label">&nbsp;</label>
                <div class="form-group" style="text-align: right">
                    <suite-rfb-confirmation-link popupTitle="Excluir do banco" (accept)="excluirRecurso()"
                            question="O recurso será excluído do banco! Confirma a operação?" style="margin-right: 1em;">
                        <button [disabled]="!recurso.idRecurso" type="button" class="btn btn-default btn-sm">Excluir do banco</button>
                    </suite-rfb-confirmation-link>
                    <button type="button" class="btn btn-default btn-sm" (click)="salvarRecurso()">Salvar no banco</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <label class="control-label">URL</label>
                <input type="text" name="url" class="form-control" [(ngModel)]="recurso.url">
            </div>
        </div>
    </ng-container>
    
    <div class="row">
        <div class="col-md-5">
            <div class="fundo-verde">
                Sinônimos
            </div>
            <div class="div-tabela">
                <table class="tabela-badges tabela">
                    <tbody>
                        <tr *ngFor="let s of recurso.sinonimos, let i = index">
                            <td style="width: 20px">
                                <em class="material-icons icone-excluir"
                                            title="Excluir sinônimo"
                                            (click)="excluirSinonimo(i)">delete
                                        </em>
                            </td>
                            <td>
                                <input type="text" name="novo-sinonimo" class="form-control" placeholder="Informe o sinônimo..." [(ngModel)]="s.sinonimo">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="fundo-verde footer">
                <em class="material-icons icon-18 incluir-sinonimo"
                            title="Incluir sinônimo"
                            (click)="incluirSinonimo()">add_box
                </em>
                Incluir um novo sinônimo
            </div>
        </div>
        <div class="col-md-4">
            <div class="fundo-verde">
                Dispositivos  <input type="text" class="filtro" [(ngModel)]="filtroDispositivo">
            </div>
            <div class="div-tabela">
                <table suiteRfbTable class="tabela-badges">
                    <tbody>
                        <tr *ngFor="let f of filtrarDispositivo(recurso.fragmentos, filtroDispositivo), let i = index">
                            <td style="width: 20px">
                                <em class="material-icons icone-excluir"
                                        *ngIf="i>0"
                                        title="Excluir dispositivo"
                                        (click)="excluirDispositivo(i)">delete
                                </em>
                            </td>
                            <td style="white-space: nowrap">
                                <span *ngIf="i===0">
                                    &nbsp;#
                                </span>
                                <span *ngIf="i!==0">
                                    &nbsp;#<input type="text" class="form-control fragmento"
                                            name="novo-fragmento"
                                            placeholder="Informe..."
                                            [(ngModel)]="f.fragmento">
                                </span>
                            </td>
                            <td>
                                <span *ngIf="i===0" style="padding: 6px 12px;">
                                    {{ f.dispositivo }}
                                </span>
                                <span *ngIf="i!==0">
                                    <input type="text" class="form-control"
                                        name="novo-dispositivo"
                                        [id]="f.fragmento"
                                        placeholder="Informe..."
                                        [(ngModel)]="f.dispositivo">
                            </span>
                            </td>
                            <td style="width: 25px;text-align: center;">
                                <em class="material-icons  selecionar-dispositivo"
                                        title="Selecionar dispositivo"
                                        (click)="selecionarDispositivo(f)">arrow_circle_up
                                </em>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="fundo-verde footer">
                <em class="material-icons icon-18 definir-dispositivo"
                            title="Incluir dispositivo"
                            (click)="incluirDispositivoManualmente()">add_box
                </em>
                <span>Incluir um novo dispositivo</span>
            </div>
        </div>
        <div class="col-md-3" *ngIf="recurso.idAto">
            <div class="fundo-verde">
                Segmentos do ato <input type="text" name="filtro-segmento" class="lupa" [(ngModel)]="filtroSegmento" (keyup)="keyupFiltroSegmento()">
            </div>
            <ng-container *ngIf="dispositivosAto && dispositivosAto.length > 0">
                <div name="tabela-segmentos" class="div-tabela">
                    <table suiteRfbTable class="tabela-badges">
                        <tbody>
                            <tr *ngFor="let d of dispositivosAto" name="tr-tabela-segmento">
                                <td style="width: 20px">
                                    <em class="material-icons adicionar-dispositivo"
                                            title="Incluir dispositivo"
                                            (click)="incluirDispositivo(d)">add_circle_outline
                                    </em>
                                </td>
                                <td>
                                    {{ d.dispositivo }}...
                                </td>
                                <td style="width: 25px;text-align: center;">
                                    <em class="material-icons selecionar-dispositivo"
                                            title="Selecionar dispositivo"
                                            (click)="selecionarDispositivo(d)">arrow_circle_up
                                    </em>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="fundo-verde footer">
                    &nbsp;
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>
